export const ERROR_MESSAGES = {
    TOTAL_BIGGER_THEN_FACT_ERROR: 'Общее количество часов в год больше, чем фактическое количество часов в год.',
    LESSONS_SUM_IN_WEEK_ERROR:
        'Суммарное количесво часов в неделю меньше, чем суммарное количество часов занятий и лекций в неделю',
    LESSONS_SUM_IN_YEAR_ERROR:
        'Суммарное количесво часов в год меньше, чем суммарное количество часов занятий и лекций в год',
    FRACTIONAL_IN_YEAR_ERR: 'Количество часов в год должно быть целым числом',
};
